import styled from "@emotion/styled/macro";

export const AuthNavContainer = styled.div`
display: flex`;
